module.exports = __webpack_public_path__ + "img/chargingport_300.c9bef8dc.png";